import styles from "./filter.module.css";

import { BrandFilter, CategoryFilter, PriceFilter, SizeFilter } from "../index";
import ColorFilter from "./ColorFilter/ColorFilter";

const FilterSection = ({
  categories,
  colors,
  minPrice,
  maxPrice,
  filtersProps,
  filtersActions,
}) => (
  <div className={styles.filterSection}>
    <div className={styles.filterGroup}>
      <CategoryFilter
        heading="CATEGORIES"
        categories={categories}
        filtersProps={filtersProps}
        filtersActions={filtersActions}
      />
    </div>

    <div className={styles.filterGroup}>
      <PriceFilter
        min={minPrice}
        max={maxPrice}
        heading={"PRICE"} 
        filtersProps={filtersProps}
        filtersActions={filtersActions}
      />
    </div>  
     {/* <div className={styles.filterGroup}>
      <ColorFilter colors={colors} />
    </div> */}

    {/* <div className={styles.filterGroup}>
      <BrandFilter
        heading={"BRAND"}
       filtersProps={filtersProps}
          filtersActions={filtersActions}
      />
    </div>

    <div className={styles.filterGroup}>
      <SizeFilter
        heading={"SIZE"}
        filtersProps={filtersProps}
        filtersActions={filtersActions}
      />
    </div> */}
  </div>
);

export default FilterSection;
